import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function StickyCTA() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <div className="fixed bottom-5 right-5 z-40 sm:bottom-8 sm:right-8">
      <Link
        to="/free-home-assessment"
        data-testid="sticky-estimate-btn"
        className="group inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-[#10B981] hover:bg-[#059669] text-white px-5 py-3.5 text-sm font-semibold sticky-cta-shadow transition-all active:scale-95"
      >
        Book Free Assessment
        <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
      </Link>
    </div>
  );
}
